export const replaceMentions = (html: string) => {
  // delete manually added mentions
  html = html.replace(/\[\[@MENTION=(.*?)\]\]/g, '');
  return html.replace(/<mention data-user-id="([^"]+)">.*?<\/mention>/gs, (match, userId) => `[[@MENTION=${userId}]]`);
};
